import api from 'modules/api';

export const getSecurityLogsRequest = (payload) => {
  return api.get('/security/logs', { params: payload });
};
